<div *ngIf="showLoading" class="loading-div-tiny" aria-live="polite" aria-busy="true" role="alert" tabindex="2">
    <div class="loading-spinner">
        <div class="small progress" alt="Loading...">
            <div class="prog1">
                <div class="prog2"></div>
            </div>
        </div>
    </div>
</div>
<ng-container *ngIf="!hideGallery">
    <div *ngIf="!error && !(cashReward[0] && cashReward[0].status == 'C')" class="point-reward-grid-container">
        <div class="tierNavigation" *ngIf="isObjectEmpty(catigorizePointsTierRewards)" #pointsTabsList role="tablist">
            <ng-container
                *ngFor="let pointTier of catigorizePointsTierRewards | keyvalue: pointComparator; let i = index">
                <div [ngClass]="currentPointTier === pointTier.key ? 'tierSelected' : ''" 
                    class="tierButton"
                    [attr.aria-label]="currentPointTier == pointTier.key ? pointTier.key +  ' points selected': pointTier.key + ' points' "
                    role="tab" 
                    id="{{pointTier.key}}tier"
                    [attr.aria-selected]="currentPointTier == pointTier.key"
                    (keydown)="handleKeydown($event,pointTier.key)"
                    (click)="setupPointsRewardGrid(pointTier.key, $event)" 
                    [tabindex]="currentPointTier == pointTier.key ? 0 : -1">
                    <span>{{pointTier.key}} pts</span>
                </div>
            </ng-container>
        </div>

        <div class="reward-grid">
            <ng-container *ngFor="let reward of rewardsSecondary; let i = index">
                <div>
                    <point-reward-card [ngClass]="rewardCardDisabled ? 'reward-grid-itme' : 'reward-card-container'"
                       [reward]="reward" [appHostURL]="appHostURL" [userInfo]="userInfo"
                       [currentEnvironment]="currentEnvironment" [enableCashReward]="enableCashReward"
                       [isPointScoreCardFlow]="pointScoreCardFlow"
                       [rewardsResponseObj]="rewardsResponseObj" #rewardCard></point-reward-card>
                </div>

            </ng-container>
        </div>

        <div id="load-more-rewards-btn" class="load-more-container"
            *ngIf="rewardsSecondary.length < rewards.length && !hideloadMoreBtn()">
            <button class="btn load-more" id="load-more-btn" aria-label="Load more rewards" role="button"
                (click)="loadMoreTierRewards()" (keyup.enter)="loadMoreTierRewards()">
                Load more
            </button>
        </div>

        <!-- Container to announce updates to screen reader users -->
        <div aria-live="polite" aria-atomic="true" class="sr-only" role="status" id="live-region">More rewards loaded
        </div>
        <br />
        <br />

    </div>
</ng-container>

<ng-container *ngIf="error && !showLoading">
    <div class="red">
        {{errorMessage}}
    </div>
</ng-container>